export const panelsWithoutData = new Set(['text', 'dashlist', 'alertlist']);
